<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalAdminSMSSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/school/lesson-note",
                title: "Metrics",
                description: "Review platform activity and key performance indicators.",
                icon: "fa fa-folder"
            },
            {
                to: "/admin/sms/school",
                title: "Schools",
                description: "View and manage schools registered on the platform.",
                icon: "fa fa-folder"
            },
            {
                to: "/admin/sms/school-subject",
                title: "School Subjects",
                description: "Create and manage the subjects offered by each school.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/homework",
                title: "Notification",
                description: "Manage notifications and deliver updates to users.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
